import { groupSectionEntityName } from '../../../../backend/config/classifiers/GroupSectionClassifier/shared';
import { useStorageGet } from '@juvare/platform-sdk-react/ui/hooks';
export function useGroupSection(id) {
    return useStorageGet(groupSectionEntityName, id);
}
